import PageLayout from "../components/PageLayout";
import WeeklyStatsBar, { computeWeeklyStats } from "../components/WeeklyStatsBar";
import useCommunityStats from "../hooks/useCommunityStats";
import usePilotStats from "../hooks/usePilotStats";
import { usePublicData } from "../hooks/usePublicData";
import { useLens } from "../lens/LensProvider";
import { fetchFeed } from "../services/feedService";
import PilotStatsTab from "./StatsPage";

function useWeeklyStats(pilotUid: string | null) {
  return usePublicData(`week:${pilotUid ?? ""}`, async () => {
    const since = new Date();
    since.setDate(since.getDate() - 7);
    since.setHours(0, 0, 0, 0);
    const feed = await fetchFeed({ limit: 500, since: since.toISOString(), pilot_uid: pilotUid ?? undefined });
    return computeWeeklyStats(feed.items, [], since);
  });
}

export default function StatsRoutePage() {
  const { activeUid } = useLens();
  const community = useCommunityStats();
  const pilot = usePilotStats(activeUid, { gaugeIds: [] });
  const week = useWeeklyStats(activeUid);

  return (
    <PageLayout route="stats" hero={{
      photo: "pilots", focus: "50% 42%", title: "Stats",
      body: "Kills, flight time, landings and where they came from.",
    }}>
      <WeeklyStatsBar stats={week.data ?? null} loading={week.loading} personal={!!activeUid} showServers={false} />
      <section className="panel panel-list pilot-panel">
        <PilotStatsTab
          pilotUid={activeUid}
          community={!activeUid}
          stats={activeUid ? pilot : community}
          typical={activeUid ? community.typical : null}
          showHighScores={false}
        />
      </section>
    </PageLayout>
  );
}
